import React from "react";
import axios from 'axios';
import { useEffect, useState } from 'react';
import $ from "jquery"
import "./ItensProdutos.css"
import { Link} from "react-router-dom";
import { ArrowReturnRight } from 'react-bootstrap-icons';
import BuscaAPI from "../Util/BuscaAPI"


export default function ItensProdutos({classCSS="desktop", idCategoria}) {
  const [menu, setMenu] = useState([]);
  const [prods, setProds] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [IDCat, setIDCat] = useState();
  const [objCat, setObjCat] = useState();

  //console.log("loading.....");

  useEffect(() => {
    const fetchItensProdutos = async () => {    
      $("#objCarregaTela").addClass("display-block");  

        //const response = await axios.get('http://localhost:21165/api/produtos');
        //const itensMenu = await axios.get("https://construmarcas.com.br/api/produtos");
        //setCategorias(response.data);
        //const itensMenu = response.data;


        const itensMenu = await BuscaAPI('https://api.construmarcas.com.br/api/produtos');
        //console.log("FIMMM loading.....");
        //const itensMenu = await BuscaAPI('http://178.156.175.191:3001/api/produtos');

        let _categorias = [];
        let c=0;
       
        let arr=[];
        itensMenu.forEach((categoria) => {
          //arr.push({nome: JSON.parse(categoria.dados).nome.toUpperCase(), ...categoria});
          arr.push({nome: JSON.parse(categoria.dados).nome, ...categoria});
        });
        
        let arrCat = [];
        arr.forEach((categoria, index) => {
          try {
            const arvoreCategoria = JSON.parse(categoria.dados).arvoreCategoria;
            if (arvoreCategoria) {
              arrCat.push(arvoreCategoria);
                arvoreCategoria.forEach((item, index) => {
                  if(!_categorias[c])
                    _categorias[c] = [];
                  _categorias[c].push(
                    {
                      index:index,
                      //...item
                      ...{
                        id:item.id,
                        idPai:item.idPai,
                        descricao: item.descricao,
                        descricaoCompleta:item.descricaoCompleta
                      }
                    }
                  )
                });
                c++;
            }
          } catch (error) {}
        });
        
        setProds(arr);
        setCategorias(arrCat);
        setMenu(_categorias);
        setIDCat(idCategoria);
        
        try{
          //console.log(JSON.parse(itensMenu.filter(item => item.idCategoria == idCategoria)[0].dados).arvoreCategoria[0]);
          setObjCat(JSON.parse(itensMenu.filter(item => item.idCategoria == idCategoria)[0].dados).arvoreCategoria[0]);        
        }catch(error){}

        //if(idCategoria)
          //$("div[id='" + idCategoria + "']").trigger("click");
        $("#objCarregaTela").removeClass("display-block");  
      };      
      fetchItensProdutos();      
  }, []);  
  
const findMenu = (items, id) => {
  let result = false;
  items.forEach((filhos, index) => { 
      if(filhos.id == id)
          result = true;
  });
  return result;
}

//remove os itens duplicados de uma array
const removeItensDuplicados = (list) => {
  const novo = [];
  list.forEach((a) => {
    a.map((b) => {
      if(findMenu(novo, b.id) == false){
        novo.push(b);
      }
    })
  });
  return novo;
} 

  const arrMenu = removeItensDuplicados(categorias);  
  arrMenu.sort((a, b) => a.descricao.localeCompare(b.descricao));

  let listaMenu = arrMenu.filter(pai => {
    pai.filhos = arrMenu.filter(filho => filho.idPai === pai.id);
    return pai.idPai === "0"
  });
  
  //console.log("listaMenu", listaMenu);

  const mm = (items) => {
    return items.map((item, index) => (
      <div key={index} id={item.id} idPai={item.idPai} index={item.index}>
        {item.index > 0 && <ArrowReturnRight className="iconCategoria" size={12} />}
        {prods.findIndex((e) => e.idCategoria == item.id) === -1 ? (
          <span className="itemSubMenu-Categorias-semProds">{item.descricao}</span>
        ) : (
          <Link className="itemSubMenu-Categorias" to={"/produtos/" + item.id}>
            {item.descricao}
          </Link>
        )}
        {
          //console.log("item.filho", item.filho)
        }
        {
        item.filho && item.filho.length > 0 && (
          // <div className="subMenu">
            mm(item.filho)
          // </div>
        )}
      </div>
    ));
  };

  const EvMouseEnter = (e) => {
    $(e.currentTarget).addClass("aberto");
    try{
      //let _cor = $(e.currentTarget).find("> span").html().split("!")[1];
      let _cor = $(e.currentTarget).attr("cor");
      if($(e.currentTarget).attr("idpai") == 0) {
        $(e.currentTarget).css("border-left", `3px solid ${_cor}`);
        //console.log("idpai", $(e.currentTarget).attr("idpai"), $(e.currentTarget).attr("idpai") == 0);
      }
    }catch(error){}
  }
  const EvMouseLeave = (e) => {
    if(!$(e.currentTarget).hasClass("selecionado"))
      $(e.currentTarget).removeClass("aberto");
    
    $(e.currentTarget).removeAttr("style");
  }
  const EvCliqueCategoria = (e) =>{
    e.stopPropagation();
    //$(".icon-mobile").trigger("click");
    //e.preventDefault();
    setIDCat($(e.currentTarget).parent().attr("id"));
    $(".ItensProdutos").find("div").removeClass("selecionado aberto");
    $(".ItensProdutos").find(".marcado").removeClass("marcado");
    $(e.currentTarget).parents("div[idPai='0']").addClass("selecionado aberto");
    $(e.currentTarget).addClass("marcado");
    $(".itensMenu").removeClass("menu-mobile");
    $(".fundo-ativo").trigger("click");

    //--corCategoriaSelecionado
    let _cor = $(e.currentTarget).parents("div[idPai='0']").attr("cor");     
    if(_cor != undefined && _cor != null && _cor != "")
      $(":root").css("--corCategoriaSelecionado", _cor);
    else
      $(":root").css("--corCategoriaSelecionado", $(":root").css("--corCategoria"));

    //console.log("cor", _cor, $(":root").css("--corCategoriaSelecionado"));
  }

  //identifica a categoria PAI da categoria atual;
  // const arrM = {...menu.find(obj => {
  //   let aa = obj[0];
  //   //console.log("aaaaaaa", aa);
  //   return obj.find((a) => {
  //     if(a.id == IDCat) {
  //       return aa;
  //     }
  //   })
  // })};
  //  arrM[0].map((a) => {
  //    console.log(a.id);
  //  });

  //let objPai = null;
  let categoriaPAI = {...objCat};
  const novoMenu = (items) => {      
    return items.map((item, index) => {
      let _descricao, _cor = "";

      try{
        _descricao = item.descricao.split("!")[0];
        _cor = item.descricao.split("!")[1];
      }catch(error){
        //console.log("erro", error);
        _descricao = item.descricao;
        _cor = "";
      }

      return (      
        //objPai = (item.idPai == 0) ? item : null,
        //className={prods.findIndex((e) => e.idCategoria == item.id && e.idCategoria == IDCat) > -1 ? "selecionado aberto" : ""}
        <div key={index} id={item.id} idPai={item.idPai} index={item.index} cor={_cor} onMouseEnter={EvMouseEnter} onMouseLeave={EvMouseLeave} className={item.id === categoriaPAI.id ? "selecionado aberto" : ""}>
          {item.index > 0 && <ArrowReturnRight className="iconCategoria" size={12} />}
          {prods.findIndex((e) => e.idCategoria == item.id) === -1 ? (
            // console.log("item", item),
            <span className="itemSubMenu-Categorias-semProds">
              {
                //item.descricao
                _descricao
              }
            </span>
          ) : (
            <Link className={(IDCat == item.id)?"itemSubMenu-Categorias marcado" : "itemSubMenu-Categorias"} to={"/produtos/" + item.id} onClick={EvCliqueCategoria}>
              {
                _descricao
                //item.descricao
              }
            </Link>
          )}
          {/* {(IDCat == item.id) ? console.log($(`div[id=${objPai}]`).addClass("selecionado aberto")) : null} */}
          {
          item.filhos && item.filhos.length > 0 && (
            // <div className="subMenu">
            novoMenu(item.filhos)
            // </div>
          )}
        </div>
      )
    });
  };
  
  return (    
      <div className={`ItensProdutos ${classCSS}`}>
        <h4>Catálogo de Produtos</h4>
        {novoMenu(listaMenu)}
      </div>
  );
}